
export const TableRow = ({children, ...rest}) => {
    return (
        <tr {...rest}>
            {children}
        </tr>
    )
}

